export default {
  webhooks: [],
};
